import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { StripeConnectAPI } from "../infrastructure/api/StripeConnect.api";

const STRIPE_STATUS_KEY = "stripe-connect-status";

export const useStripeConnectStatus = () =>
    useQuery({
        queryKey: [STRIPE_STATUS_KEY],
        queryFn: async () => {
            const { data } = await StripeConnectAPI.status();
            return data;
        },
    });

/**
 * Start the Connect flow.
 *
 * Fetches the consent URL over the authenticated client, then navigates the
 * whole page to it. Stripe's consent screen cannot live in an XHR response,
 * and the API endpoint cannot be a plain redirect target because the browser
 * would send no auth header on a top-level navigation.
 */
export const useStartStripeConnect = () =>
    useMutation({
        mutationFn: async () => {
            const { data } = await StripeConnectAPI.authorizeUrl();
            window.location.assign(data.url);
        },
    });

export const useRevokeStripeConnect = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => StripeConnectAPI.revoke(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [STRIPE_STATUS_KEY] });
            // An issued payment's payment link dies with the connection, so
            // the payment list is stale too.
            queryClient.invalidateQueries({ queryKey: ["payments"] });
        },
    });
};
